module.exports = __webpack_public_path__ + "static/img/post.4f1521cb.svg";